export const enumToTemplate = {
  1: 'input',
  101: 'phone',
  102: 'id-number',
  2: 'number',
  3: 'switch',
  401: 'date',
  402: 'time',
  403: 'date-time',
  6: 'radio',
  7: 'checkbox',
}

export const templateToEnum = {
  'text': 1,
  'input': 1,
  'select': 6,
  'textarea': 1,
  'phone': 101,
  'id-number': 102,
  'number': 2,
  'switch': 3,
  'date': 401,
  'time': 402,
  'radio': 6,
  'datetime': 403,
  'checkbox': 7,
}
